export default __webpack_public_path__ + "static/media/boy.70470b91.svg";